<style></style>
<template>
    <div class="page-container" role="tablist">
        <h1>Step 4: Learn More</h1>

        <section-collapse accordion="step-4-learn-more" id="step-4-learn-more-why-important">
            <template #title>Why it's Important</template>
            <template #collapsed-content>
                <p>Training is highly recommended, but not required. Training ensures that child care providers have the knowledge and skills needed to meet best practices. Consider both formal and informal training options. Formal in-person or online trainings often cover a topic more in depth. The time invested could earn child care providers credit toward required continuing education hours. However, when time is limited, training can also be provided more informally at staff meetings by introducing a specific goal and encouraging staff to share their ideas and experiences.</p>
            </template>
        </section-collapse>

        <section-collapse accordion="step-4-learn-more" id="step-4-learn-more-activities">
            <template #title>
                Activities
            </template>
            <template #collapsed-content>
                <activity-collapse accordion="step-4-activities">
                    <template #number>1</template>
                    <template #title><strong>Consultant</strong> indentifies formal and informal training options</template>
                    <template #collapsed-content>
                        <p>Your work with child care providers up to this point will give you a sense of their training needs. You may direct them toward the Go NAPSACC trainings or specific resources from the tips &amp; materials library. You can also connect them to relevant in-person training opportunities available in your community.</p>

                        <h5>Training resources through Go NAPSACC</h5>
                        <p>To support formal trainings, Provider Tools include some recorded webinars on Child Nutrition and Physical Activity. Child care providers can access these trainings at any time on the Training page. These trainings are designed to be interactive and include time for reflection and planning. At the end of the training, child care providers complete a brief evaluation, which allows Go NAPSACC to provide a certificate of participation. Go NAPSACC is a recognized training organization with the National Workforce Registry Alliance.</p>
                        <p>The tips &amp; materials library offers helpful resources for informal trainings at staff meetings. All modules offer Teacher &amp; Staff Resources, which provide a basic introduction to the topic and some tips for how to get started. These resources can be great conversation starters.</p>

                        <h5>In-person trainings available locally</h5>
                        <p>In-person training with a trusted, skilled trainer is a great benefit to child care providers. However, it is important to review training materials for consistency with Go NAPSACC best practices to help child care providers apply the knowledge learned. It is also helpful to use videos, activity ideas, and other guidance documents from the tips &amp; materials library because the child care providers have easy access to them after the training. When planning in-person trainings, consider the following:</p>
                        
                        <h5>Scheduling </h5>
                            <ul class="fa-ul">
                                <li>Plan around child care providers’ schedules. </li>
                                <li>Consider evening or weekend trainings. </li>
                                <li>Look for times when child care providers are already gathered, such as conferences or other events.</li>
                                <li>When possible, cover costs such as registration fees, travel, substitute teachers, and overtime for evening or weekend trainings.</li>
                            </ul>
                   
                        <h5>Active learning</h5>
                            
                            <p>Hands-on activities help child care providers build the skills to meet and sustain best practices. They also make training sessions more interesting. Examples of hands-on activities include:</p>
                            <ul class="fa-ul">
                                <li>Child Nutrition: menu review, label reading, practice with child activities, practice family style dining</li>
                                <li>Physical Activity: schedule review, practice lesson planning, practice leading gross motor development activities</li>
                            </ul>
                        
                            <p>Peer-to-peer learning in trainings allows child care providers to share and learn from their peers. These group conversations can come up with creative solutions to common challenges. Great ways to foster peer-to-peer learning include:</p>
                            <ul class="fa-ul">
                                <li>Invite past participants to trainings to share experiences either on a panel or in small group discussions around specific topics or challenges.</li>
                                <li>Encourage child care providers to visit more experienced peers to see nutrition and physical activity best practices in action.</li>
                            </ul>

                        <h5>Identifying local resources </h5>
                        <p>You may be able to offer some of these in-person trainings to child care providers depending on your time and comfort with the topic. In many communities, trainings may be available through:</p>
                        <ul class="fa-ul">
                            <li>the organization coordinating your state’s Go NAPSACC work</li>
                            <li>your state’s Child and Adult Care Food Program (CACFP) office or CACFP sponsor organizations</li>
                            <li>regional/local Child Care Aware or Child Care Resource &amp; Referral office</li>
                            <li>local or state health department, parks &amp; rec, or cooperative extension offices</li>
                            <li>universities or local community colleges</li>
                        </ul>
                            

                    </template>
                </activity-collapse>
            </template>
        </section-collapse>

        <section-collapse accordion="step-4-learn-more" id="step-4-learn-more-challenges-and-solutions">
            <template #title>
                Common Challenges &amp; Solutions
            </template>
            <template #collapsed-content>
                <h4 class="mt-0">Missing certificate from Go NAPSACC training</h4>
                <p>A child care provider must take the evaluation at the end of the training in order to receive a certificate. Training certificates are issued at the beginning of each month for the month prior. If a child care provider has taken the training and completed the evaluation and needs their certificate sooner, they can request it by emailing <a href="mailto:gonapsacc@unc.edu">gonapsacc@unc.edu</a>.</p>
            </template>
        </section-collapse>

        <section-collapse accordion="step-4-learn-more" id="step-4-learn-more-support-documents">
            <template #title>
                Support Documents
            </template>
            <template #collapsed-content>
                <slot name="support-docs"><div>some backup text for support docs in enrollment</div></slot>
            </template>
        </section-collapse>
    </div>
</template>

<script>
    import SectionCollapse from '../../TaResources/SectionCollapse.vue';
    import HelpfulHints from '../../TaResources/HelpfulHints.vue';
    import ActivityCollapse from '../../TaResources/ActivityCollapse.vue';
    import ConsultantToolsSpotlight from '../../TaResources/ConsultantToolsSpotlight.vue';
    import ProviderToolsSpotlight from '../../TaResources/ProviderToolsSpotlight.vue';    

    export default {
        components: {
            SectionCollapse,
            HelpfulHints,
            ActivityCollapse,
            ConsultantToolsSpotlight,      
            ProviderToolsSpotlight,                  
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>